import React from "react";
import PropTypes from "prop-types";
import CardWrapper from "./CardWrapper";

import classnames from "classnames";

import { makeScroll } from "./utils";

import Card from "../Card/Card.js";

export default class Slider24Smi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      leftEdgeVisible: false,
      rightEdgeVisible: false,
      leftButtonVisible: false,
      rightButtonVisible: false
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.checkEdgeVisibility);
    this.scroller.addEventListener("scroll", this.checkEdgeVisibility);
    this.checkEdgeVisibility();
  }

  componentDidUpdate(prevProps) {
    if (this.props.items !== prevProps.items) {
      this.scroller.scrollTo(0, 0);

      this.checkEdgeVisibility();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkEdgeVisibility);
    this.scroller.removeEventListener("scroll", this.checkEdgeVisibility);
  }

  getLeftPadding = () => {
    return parseInt(window.getComputedStyle(this.scroller).paddingLeft);
  };

  getCardWidth = () => {
    const styles = window.getComputedStyle(this.card.base);
    const width = parseInt(styles.width);
    const marginLeft = parseInt(styles.marginLeft);
    const marginRight = parseInt(styles.marginRight);
    return width + marginLeft + marginRight;
  };

  checkEdgeVisibility = () => {
    const leftEdgeVisible = this.scroller.scrollLeft > this.getLeftPadding();

    const rightEdgeVisible =
      this.scroller.scrollLeft + this.scroller.clientWidth <
      this.scroller.scrollWidth - this.getLeftPadding();

    this.setState({ leftEdgeVisible, rightEdgeVisible });
  };

  handleMouseLeave = () => {
    this.setState({
      leftButtonVisible: false,
      rightButtonVisible: false
    });
  };

  handelMouseMove = e => {
    if (this.screenX != undefined) {
      let delta = this.screenX - e.screenX;
      this.screenX = e.screenX;

      makeScroll(this.scroller, {
        top: 0,
        left: delta
      });
    }

    const pageX = e.pageX;
    const rect = this.scroller.getBoundingClientRect();
    const elementX = pageX - rect.left;

    this.setState(prevState => {
      const state =
        elementX < rect.width / 2
          ? {
              leftButtonVisible: prevState.leftEdgeVisible,
              rightButtonVisible: false
            }
          : {
              leftButtonVisible: false,
              rightButtonVisible: prevState.rightEdgeVisible
            };

      if (this.screenX != undefined) {
        state.realMove = true;
      }
      return state;
    });
  };

  handleMouseDown = e => {
    this.screenX = e.screenX;
  };

  handleMoveStop = e => {
    this.screenX = undefined;
    this.setState({ realMove: false });
  };

  getTargetScrollCount = cardWidth => {
    const clientWidth = this.scroller.clientWidth;
    return Math.max(
      Math.floor((clientWidth - this.getLeftPadding()) / cardWidth),
      1
    );
  };

  handleLeftClick = () => {
    const cardWidth = this.getCardWidth();
    const scrollLeft = this.scroller.scrollLeft;

    let hiddenCount = scrollLeft / cardWidth;
    hiddenCount =
      hiddenCount % 1 >= 0.5 ? Math.ceil(hiddenCount) : Math.floor(hiddenCount);

    const targetHiddenCount = Math.max(
      hiddenCount - this.getTargetScrollCount(cardWidth),
      0
    );
    const scrollIndent = targetHiddenCount * cardWidth - scrollLeft;

    makeScroll(this.scroller, {
      top: 0,
      left: scrollIndent,
      behavior: "smooth"
    });
  };

  handleRightClick = () => {
    const cardWidth = this.getCardWidth();

    const scrollLeft = this.scroller.scrollLeft;
    const clientWidth = this.scroller.clientWidth;

    let shownCount =
      (scrollLeft + clientWidth - this.getLeftPadding()) / cardWidth;

    shownCount =
      shownCount % 1 >= 0.5 ? Math.ceil(shownCount) : Math.floor(shownCount);

    const targetShowCount = Math.min(
      shownCount + this.getTargetScrollCount(cardWidth),
      this.props.items.length + 1
    );

    const scrollIndent =
      targetShowCount * cardWidth -
      (scrollLeft + clientWidth) +
      this.getLeftPadding();

    makeScroll(this.scroller, {
      top: 0,
      left: scrollIndent,
      behavior: "smooth"
    });
  };

  render() {
    const classNames = classnames(
      {
        slider24smi_edge_left: this.state.leftEdgeVisible,
        slider24smi_edge_right: this.state.rightEdgeVisible,
        "slider24smi_button-left": this.state.leftButtonVisible,
        "slider24smi_button-right": this.state.rightButtonVisible,
        slider24smi_moving: this.state.realMove
      },
      "slider24smi"
    );

    return (
      <div className={classNames}>
        <div
          className="slider24smi__inner"
          onMouseLeave={this.handleMouseLeave}
        >
          <div className="slider24smi__edge-left">
            <div className="slider24smi__edge-shadow" />
            <div
              className="slider24smi__edge-button"
              onClick={this.handleLeftClick}
            />
          </div>

          <div className="slider24smi__edge-right">
            <div className="slider24smi__edge-shadow" />
            <div
              className="slider24smi__edge-button"
              onClick={this.handleRightClick}
            />
          </div>

          <div className="slider24smi__cards">
            <div
              className="slider24smi__scroller"
              ref={el => (this.scroller = el)}
              onMouseMove={this.handelMouseMove}
              onMouseDown={this.handleMouseDown}
              onMouseUp={this.handleMoveStop}
              onMouseLeave={this.handleMoveStop}
            >
              {this.props.items.map((cardData, i) => {
                // Проверяем наличие ID один раз в начале
                if (!cardData.cid) {
                  console.error(`Card ID (cid) is missing for card at index ${i}`);
                  return null;
                }

                return (
                  <CardWrapper ref={el => (this.card = el)} key={cardData.cid} i={i}>
                    <Card
                      card={cardData}
                      onTakeOnClick={() => {
                        this.props.onTakeOn({
                          id: cardData.cid,
                          userId: cardData.user_id
                        });
                      }}
                      onTakeOffClick={() => {
                        this.props.onTakeOff({
                          id: cardData.cid,
                          userId: cardData.user_id
                        });
                      }}
                      onSetHidden={hidden => {
                        this.props.onSetHidden({ id: cardData.cid, hidden });
                      }}
                      onSetRatio={ratio => {
                        this.props.onSetRatio({ id: cardData.cid, ratio });
                      }}
                      onSetPacket={packet => {
                        this.props.onSetPacket({ id: cardData.cid, packet });
                      }}
                      canTakeOn={this.props.canTakeOn}
                      canTakeOff={this.props.user.id == cardData.user_id}
                      permissions={this.props.permissions}
                    />
                  </CardWrapper>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Slider24Smi.propTypes = {
  items: PropTypes.array.isRequired,
  onTakeOn: PropTypes.func,
  onTakeOff: PropTypes.func
};
